import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1406cd06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ignore_com-top" }
const _hoisted_2 = { class: "page-search content-box ptheader" }
const _hoisted_3 = { class: "search-box" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanIcon = _resolveComponent("VanIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "header-return",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
      }, [
        _createVNode(_component_VanIcon, { name: "arrow-left" })
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          (_ctx.searchData &&  _ctx.searchData.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.searchData, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "space-item",
                  onClick: ($event: any) => (_ctx.triggerSearchSpace(item))
                }, [
                  _createElementVNode("img", {
                    src: _ctx.parseImgUrl('search-icon','icon_meetingroom.svg'),
                    alt: ""
                  }, null, 8, _hoisted_5),
                  _createElementVNode("p", null, _toDisplayString(item.localName), 1)
                ], 8, _hoisted_4))
              }), 256))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}